/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessingJobModelDto } from '../../models/processing-job-model-dto';

export interface MatchVideoControllerCancel$Params {
  uuid: string;
}

export function matchVideoControllerCancel(http: HttpClient, rootUrl: string, params: MatchVideoControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessingJobModelDto>> {
  const rb = new RequestBuilder(rootUrl, matchVideoControllerCancel.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessingJobModelDto>;
    })
  );
}

matchVideoControllerCancel.PATH = '/match-videos/{uuid}/cancel';
